export const DeclarationCotisationOld = {
    path: '/declaration_cotisation_old',
    name: 'declaration_cotisation_old',
    component: () => import('@/views/Impression/DeclarationCotisation/DeclarationCotisationOldPage.vue'),
    children: [
        {
            path: '/contribution_declarations_old/add',
            name: 'contribution_declarations_old.add',
            component: () => import('@/views/ContributionDeclaration/Form/ContributionDeclarationForm.vue'),
            props: {addAction: true, type: 'DECLARATION_COTISATION_OLD'}
        },
        {
            path: '/contribution_declarations_old/edit/:id',
            name: 'contribution_declarations_old.edit',
            component: () => import('@/views/ContributionDeclaration/Form/ContributionDeclarationForm.vue'),
            props: {updateAction: true, type: 'DECLARATION_COTISATION_OLD'}
        },
        {
            path: '/contribution_declarations_old/delete/:id',
            name: 'contribution_declarations_old.delete',
            component: () => import('@/views/ContributionDeclaration/Form/ContributionDeclarationForm.vue'),
            props: {deleteAction: true, type: 'DECLARATION_COTISATION_OLD'}
        },
        {
            path: '/contribution_declarations_old/view/:id',
            name: 'contribution_declarations_old.view',
            component: () => import('@/views/ContributionDeclaration/Form/ContributionDeclarationForm.vue'),
            props: {viewAction: true, type: 'DECLARATION_COTISATION_OLD'}
        },
    ]
}